"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "getTokenHeader", {
  enumerable: true,
  get: function get() {
    return _getTokenHeader["default"];
  }
});
Object.defineProperty(exports, "getValidToken", {
  enumerable: true,
  get: function get() {
    return _getTokenHeader.getValidToken;
  }
});
Object.defineProperty(exports, "isTokenExpired", {
  enumerable: true,
  get: function get() {
    return _jwtHelper.isTokenExpired;
  }
});
Object.defineProperty(exports, "getTokenExpirationDate", {
  enumerable: true,
  get: function get() {
    return _jwtHelper.getTokenExpirationDate;
  }
});
Object.defineProperty(exports, "decodeToken", {
  enumerable: true,
  get: function get() {
    return _jwtHelper.decodeToken;
  }
});
Object.defineProperty(exports, "getToken", {
  enumerable: true,
  get: function get() {
    return _manageTokens.getToken;
  }
});
Object.defineProperty(exports, "updateTokens", {
  enumerable: true,
  get: function get() {
    return _manageTokens.updateTokens;
  }
});
Object.defineProperty(exports, "clearTokens", {
  enumerable: true,
  get: function get() {
    return _manageTokens.clearTokens;
  }
});
Object.defineProperty(exports, "normalizeTokens", {
  enumerable: true,
  get: function get() {
    return _normalizeTokens.normalizeTokens;
  }
});

var _getTokenHeader = _interopRequireWildcard(require("./getTokenHeader"));

var _jwtHelper = require("./jwtHelper");

var _manageTokens = require("./manageTokens");

var _normalizeTokens = require("./normalizeTokens");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }